export const CyCopyMovePlaylistsModal = {
  CopyMovePlaylistsModal: "CopyMovePlaylistsModal",
  ButtonCopy: "ButtonCopy",
  ButtonMove: "ButtonMove",
} as const;
